export default class Accordion {
  /**
   * Constructor
   *
   * @param {Element} el HTML element
   */
  constructor(el) {
    this.wrapper = el
    this.items = Array.from(this.wrapper.querySelectorAll('.accordion__item'))

    if (this.items.length) {
      this.init()
    }
  }

  reset() {
    this.items.forEach(item => {
      const content = item.querySelector('.accordion__item__content')
      item.classList.remove('accordion__item--open')
      content.removeAttribute('style')
    })
  }

  open(item) {
    const content = item.querySelector('.accordion__item__content')
    item.classList.add('accordion__item--open')
    content.style.height = `${content.scrollHeight}px`
  }

  init() {
    this.items.forEach((item, index) => {
      const toggle = item.querySelector('.accordion__item__toggle')

      if (index === 0 && item.classList.contains('accordion__item--open')) {
        this.open(item)
      }

      if (toggle) {
        toggle.addEventListener('click', e => {
          const isOpen = item.classList.contains('accordion__item--open')
          e.preventDefault()
          this.reset()
          if (!isOpen) {
            this.open(item)
          }
          e.stopPropagation()
        })
      }
    })
  }
}
